import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export type FuelVehicleTypeKey = 'ON_ROAD' | 'OFF_ROAD';
export type FuelLastUpdatedSource = 'MANUAL' | 'BC_SYNC';

export interface FuelManagementRow {
  id: number;
  vehicleType: FuelVehicleTypeKey;
  surchargePerHour: string;
  lastUpdatedSource: FuelLastUpdatedSource;
  updatedAt: string;
  updatedBy: {
    id: number;
    name: string;
    lastName: string;
  } | null;
}

export interface FuelSurchargeHistoryRow {
  id: number;
  vehicleType: FuelVehicleTypeKey;
  surchargePerHour: string;
  effectiveAt: string;
  source: FuelLastUpdatedSource;
  comment: string | null;
  updatedBy: {
    id: number;
    name: string;
    lastName: string;
  } | null;
}

const axiosConfig = { withCredentials: true as const };

export const fuelManagementService = {
  async list(): Promise<FuelManagementRow[]> {
    const { data } = await axios.get<FuelManagementRow[]>(`${API_URL}/admin/fuel-management`, axiosConfig);
    return data;
  },

  async updateRow(
    id: number,
    body: { surchargePerHour?: number; comment?: string | null }
  ): Promise<FuelManagementRow> {
    const { data } = await axios.patch<FuelManagementRow>(
      `${API_URL}/admin/fuel-management/${id}`,
      body,
      axiosConfig
    );
    return data;
  },

  /** All vehicle types combined, newest effective date first. */
  async listHistory(): Promise<FuelSurchargeHistoryRow[]> {
    const { data } = await axios.get<FuelSurchargeHistoryRow[]>(
      `${API_URL}/admin/fuel-management/history`,
      axiosConfig
    );
    return data;
  },

  async updateHistory(
    id: number,
    body: { surchargePerHour?: number; effectiveAt?: string; comment?: string | null }
  ): Promise<FuelSurchargeHistoryRow> {
    const { data } = await axios.patch<FuelSurchargeHistoryRow>(
      `${API_URL}/admin/fuel-management/history/${id}`,
      body,
      axiosConfig
    );
    return data;
  },

  async createHistory(body: {
    vehicleType: FuelVehicleTypeKey;
    surchargePerHour: number;
    effectiveAt: string;
    comment?: string | null;
  }): Promise<FuelSurchargeHistoryRow> {
    const { data } = await axios.post<FuelSurchargeHistoryRow>(
      `${API_URL}/admin/fuel-management/history`,
      body,
      axiosConfig
    );
    return data;
  }
};

export default fuelManagementService;
